export enum Screen {
    Home = 'Home',
    Login = 'Login',
    Register = 'Register'
}
